/* eslint-disable sonarjs/no-duplicate-string */
export const ProductCategoriesValues = [
    {
        productCategoryId: 1010,
        productCategory: 'External venetian blinds',
        businessUnit: 'Window Systems',
        value: 1720,
    },
    {
        productCategoryId: 1020,
        productCategory: 'Roller shutters',
        businessUnit: 'Window Systems',
        value: 3180,
    },
    {
        productCategoryId: 1030,
        productCategory: 'Window awnings',
        businessUnit: 'Window Systems',
        value: 3020,
    },
    {
        productCategoryId: 1040,
        productCategory: 'Light guidance systems',
        businessUnit: 'Window Systems',
        value: 1720,
    },
    {
        productCategoryId: 1060,
        productCategory: 'Insect screen & pollen protection',
        businessUnit: 'Window Systems',
        value: 500,
    },
    {
        productCategoryId: 2010,
        productCategory: 'Venetian blinds',
        businessUnit: 'Inside',
        value: 350,
    },
    {
        productCategoryId: 2020,
        productCategory: 'Roller blinds',
        businessUnit: 'Inside',
        value: 670,
    },
    {
        productCategoryId: 2040,
        productCategory: 'Curtain panels',
        businessUnit: 'Inside',
        value: 970,
    },
    {
        productCategoryId: 2050,
        productCategory: 'Vertical louvre blinds',
        businessUnit: 'Inside',
        value: 350,
    },
    {
        productCategoryId: 2060,
        productCategory: 'Back-out blinds',
        businessUnit: 'Inside',
        value: 2070,
    },
    {
        productCategoryId: 3010,
        productCategory: 'Sun sail',
        businessUnit: 'Outdoor Living',
        value: 5800,
    },
    {
        productCategoryId: 3020,
        productCategory: 'Patio awnings',
        businessUnit: 'Outdoor Living',
        value: 1870,
    },
    {
        productCategoryId: 3030,
        productCategory: 'Conservatory awnings',
        businessUnit: 'Outdoor Living',
        value: 2020,
    },
    {
        productCategoryId: 3040,
        productCategory: 'Slat roofs',
        businessUnit: 'Outdoor Living',
        value: 10050,
    },
    {
        productCategoryId: 3050,
        productCategory: 'Pergola awnings',
        businessUnit: 'Outdoor Living',
        value: 4010,
    },
    {
        productCategoryId: 4010,
        productCategory: 'Smart Home solutions',
        businessUnit: 'Smart Building Solutions',
        value: 220,
    },
    {
        productCategoryId: 4020,
        productCategory: 'Radio control',
        businessUnit: 'Smart Building Solutions',
        value: 220,
    },
    {
        productCategoryId: 4030,
        productCategory: 'Central control',
        businessUnit: 'Smart Building Solutions',
        value: 220,
    },
    {
        productCategoryId: 4050,
        productCategory: 'WAREMA climatronic',
        businessUnit: 'Smart Building Solutions',
        value: 220,
    },
];
